<script>
import options from './FormInputTextarea.options'
export default options
</script>

<template>
  <div
    class="Form__Element FormTextbox kb-form-input-textarea"
    :class="{ ValidationRequired: isRequired }"
  >
    <label :for="fieldName" class="Form__Element__Caption">
      {{ label }}

      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
    </label>

    <textarea
      class="FormTextbox__Input"
      v-model="localValue"
      :autocomplete="autocomplete"
      :required="isRequired ? true : false"
      :class="{ 'validation-error': isValidationError }"
      :id="fieldName"
      :aria-describedby="`${fieldName}__desc`"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="formLink"
      :disabled="readOnly"
    ></textarea>

    <p
      class="kb-form__input-helptext"
      v-if="helpMessageLabel"
    >
      {{ helpMessageLabel }}
    </p>

    <div aria-live="assertive">
      <p class="kb-forms Form__Element__ValidationError"
         role="alert"
         v-if="inputHasValidationErrors && isValidationError">
        {{ errorMessageLabel }}
      </p>
    </div>

  </div>
</template>
